import { NgModule } from '@angular/core';
import { translationChunksConfig, translationsCs } from "@spartacus/assets";
import { I18nConfig, provideConfig, provideConfigFactory } from "@spartacus/core";
import { defaultCmsContentProviders, layoutConfig, MediaConfig } from "@spartacus/storefront";

import { slbTranslationsConfig } from '../core/i18n/slb-i18n.config';
import { slbLayoutConfig } from "../layouts/layout";
import { SlbConfigService } from '../core/services/slb-config.service';
import { slbConfig } from '../core/config/slb-config';



@NgModule({
  declarations: [],
  imports: [
  ],
  providers: [
    provideConfigFactory(slbConfig, [SlbConfigService]),
    provideConfig(layoutConfig),
    ...defaultCmsContentProviders,
    provideConfig(<I18nConfig>{
      i18n: {
        resources: translationsCs,
        chunks: translationChunksConfig,
        fallbackLang: 'en'
      },
    }),
    provideConfig(slbTranslationsConfig),
    provideConfig({
      features: {
        level: '2211.38.1'
      }
    }),
    provideConfig(slbLayoutConfig),
  ]
})
export class SpartacusConfigurationModule { }
